import React from "react";
import GenericPullAndPushToolView from "../GenericPullAndPushToolView";
import SynopsysPolarisCredentialsForm from "./SynopsysPolarisCredentialsForm";
import SynopsysPolarisConfigListing from "./SynopsysPolarisConfigListing";

export default function SynopsysPolarisPullAndPushView(props) {
  return (
    <GenericPullAndPushToolView
      {...props}
      PullCredentialForm={SynopsysPolarisCredentialsForm}
      PullConfigListingView={SynopsysPolarisConfigListing}
    />
  );
}
